"use client"

import { HeroHeader } from "@/components/marketing/2026/mist-hero/header"
import { Pricing, PricingComparator, Footer } from "@/components/marketing/2026"
import { StripedPattern } from "@/components/ui/striped-pattern"

export function PricingPageContent() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <HeroHeader />
            <main>
                {/* Pricing Hero with Ecommaps branded background */}
                <section className="before:bg-muted border-b border-border relative overflow-hidden before:absolute before:inset-1 before:rounded-2xl sm:before:inset-2 md:before:rounded-[2rem]">
                    {/* Striped Pattern Background */}
                    <div className="absolute inset-1 sm:inset-2 rounded-2xl md:rounded-[2rem] overflow-hidden">
                        <StripedPattern
                            direction="left"
                            className="text-foreground/[0.03] dark:text-foreground/[0.02]"
                        />
                    </div>
                    <div className="pt-24 relative">
                        <Pricing />
                    </div>
                </section>

                {/* Comparator Table */}
                <PricingComparator />
            </main>
            <Footer />
        </div>
    )
}
